const OWNER_TOKEN_PATTERN = /^[A-Za-z0-9_-]{32,128}$/u;
const OWNER_FRAGMENT_KEY = "access";

export interface ParsedOwnerAccess {
  present: boolean;
  token: string | null;
}

export function isOwnerToken(value: unknown): value is string {
  return typeof value === "string" && OWNER_TOKEN_PATTERN.test(value);
}

export function buildPrivateManagementUrl(origin: string, slug: string, ownerToken: string): string {
  if (!isOwnerToken(ownerToken)) throw new Error("Invalid owner token");
  const url = new URL("/", origin);
  url.searchParams.set("manage", slug);
  url.hash = new URLSearchParams({ [OWNER_FRAGMENT_KEY]: ownerToken }).toString();
  return url.toString();
}

export function parseOwnerAccessFragment(hash: string): ParsedOwnerAccess {
  const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
  if (!params.has(OWNER_FRAGMENT_KEY)) return { present: false, token: null };
  const token = params.get(OWNER_FRAGMENT_KEY);
  return { present: true, token: isOwnerToken(token) ? token : null };
}
